'use client';

import { Lock } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

import { authClient } from '@/lib/auth-client';

const LoginPrompt = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const { error } = await authClient.signIn.magicLink({
        email,
      });

      if (error) {
        setError(error.message || 'Fehler beim Senden des Magic Links');
      } else {
        setSent(true);
      }
    } catch (err) {
      setError('Fehler beim Senden des Magic Links');
      console.error('Error sending magic link:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-sm max-w-full rounded-lg border p-4">
      <div className="flex flex-col items-center gap-4">
        <Lock size={64} />
        <p className="text-2xl">Zugang geschützt!</p>
        {sent ? (
          <p>
            Magic Link wurde an {email} gesendet. Bitte prüfen Sie Ihr
            E-Mail-Postfach.
          </p>
        ) : (
          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <div className="space-y-2">
              <Label htmlFor="login-email">
                E-Mail <span className="text-red-500">*</span>
              </Label>
              <Input
                id="login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ihre@email.de"
              />
            </div>
            {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
            <Button type="submit" className="mt-4 w-full" disabled={loading}>
              {loading ? 'Wird gesendet...' : 'Magic Link senden'}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};

export default LoginPrompt;
